import {useEffect} from 'react';

const ignoredTags = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA', 'INPUT', 'SELECT', 'OPTION', 'CODE', 'PRE']);
const shortWords = [
    'а',
    'в',
    'во',
    'да',
    'до',
    'за',
    'и',
    'из',
    'или',
    'к',
    'ко',
    'на',
    'не',
    'но',
    'о',
    'об',
    'от',
    'по',
    'при',
    'про',
    'с',
    'со',
    'у',
];
const shortWordPattern = new RegExp(`(^|[\\s([{"'«„])(${shortWords.join('|')})[ \\t]+`, 'giu');

const shouldSkipNode = (node) => {
    const parent = node.parentElement;
    return !parent || ignoredTags.has(parent.tagName);
};

const applyTypography = (root) => {
    if (!root) {
        return;
    }

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const textNodes = [];

    while (walker.nextNode()) {
        textNodes.push(walker.currentNode);
    }

    textNodes.forEach((node) => {
        if (shouldSkipNode(node)) {
            return;
        }

        const nextValue = node.nodeValue.replace(shortWordPattern, '$1$2\u00A0');

        if (nextValue !== node.nodeValue) {
            node.nodeValue = nextValue;
        }
    });
};

const NonBreakingSpaces = () => {
    useEffect(() => {
        applyTypography(document.body);

        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === Node.TEXT_NODE) {
                        applyTypography(node.parentElement);
                    }

                    if (node.nodeType === Node.ELEMENT_NODE) {
                        applyTypography(node);
                    }
                });
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });

        return () => observer.disconnect();
    }, []);

    return null;
};

export default NonBreakingSpaces;
